import { ConfirmOptions } from "@solana/web3.js";

export const TXN_OPTS: ConfirmOptions = {
  commitment: "confirmed",
  preflightCommitment: "processed",
  skipPreflight: false,
};
